import type { PersonContact } from '~/interfaces/person'
import type { ILanguage, IRelevance, IThesis } from '~/interfaces/thesis'
import type { ThesisStatus } from '~/constants/domain'

export class Thesis implements IThesis {
  /**
   * This constructor is only called by static methods.
   * @param supervisor
   * @param tutor
   * @param relevance
   * @param status
   * @param studentName
   * @param languageSpecific
   * @param supervisorPerson
   * @param tutorPerson
   */
  private constructor(
    public supervisor: string,
    public tutor: string,
    public relevance: Array<IRelevance>,
    public status: ThesisStatus,
    public studentName: string,
    public languageSpecific: Array<ILanguage>,
    public supervisorPerson?: PersonContact,
    public tutorPerson?: PersonContact,
  ) {}

  /**
   * Create a new Thesis object from data conforming to the interface.
   * @param thesis Thesis data conforming to the interface.
   * @param supervisor Narrow person contact data.
   * @param tutor Narrow person contact data.
   * @returns {Thesis}
   */
  static create(
    thesis: IThesis,
    supervisor?: PersonContact,
    tutor?: PersonContact,
  ): Thesis {
    return new Thesis(
      thesis.supervisor,
      thesis.tutor,
      thesis.relevance,
      thesis.status,
      thesis.studentName,
      thesis.languageSpecific,
      supervisor,
      tutor,
    )
  }

  // Required
  toJSON(): Thesis {
    return { ...this }
  }
}
